export default __webpack_public_path__ + "static/prepared-c545e945808a68d6bd7b41e0e97af265.png";